import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Button from "~/shared/ui/Fields/Button";
import Back from "~/components/Icons/arrow-prev2";

import s from "./EditorInformationSystems.less";

import { usePermissions } from "~/shared/context/PermissionContext";
import { options } from "./options";

const EditorInformationSystems = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const goBack = () => history.replace("/editor/");

  return (
    <div className={s.wrapper_editor}>
      <div className={s.header}>
        <div className={s.title}>{t("directories.directories")}</div>
        <Button
          txtBtn={t("ui.back")}
          onClick={goBack}
          small
          customClassName={s.button_small}
        >
          <Back />
        </Button>
      </div>
      <div className={s.wrapper_items}>
        {options.map((item) => {
          if (loadingPermissions || !hasPermission(item.permissions)) {
            return null;
          }

          return (
            <div className={s.item} key={item.id}>
              <div className={s.item__content}>
                <div className={s.item__title}>
                  {t(`editor.${item.description_lang_key}`)}
                </div>
              </div>
              <div className={s.button}>
                <Button
                  txtBtn={t("ui.go_over")}
                  orange
                  onClick={() => history.push(item.path)}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EditorInformationSystems;
